import { FileMessage } from "~/components/assistant/messages/FileMessage";
import type { TextFile } from "~/components/assistant/types";

interface TextFileMessageProps {
  textFile: TextFile;
  debugMode?: boolean;
}

export function TextFileMessage({ textFile, debugMode = false }: TextFileMessageProps) {
  return <FileMessage file={textFile} artifactType="text_file" debugMode={debugMode} />;
}
